import Markdown from 'react-markdown';

const ALIGN_CLASSES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};

const GlossaryTable = ({ caption, headers = [], rows = [] }) => {
  if (!rows.length) return null;

  return (
    <figure className="my-2">
      {caption && <figcaption className="text-grey-600 mb-3 text-sm">{caption}</figcaption>}
      <div className="border-grey-200 overflow-x-auto rounded-2xl border">
        <table className="text-grey-800 w-full text-[15px]">
          {headers.length > 0 && (
            <thead>
              <tr className="bg-grey-50">
                {headers.map((header) => (
                  <th
                    key={header.id}
                    className={`text-grey-500 px-4 py-3 text-xs font-semibold tracking-wider uppercase ${ALIGN_CLASSES[header.align] || ALIGN_CLASSES.left}`}
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={row.id} className={rowIndex < rows.length - 1 ? 'border-grey-200 border-b' : ''}>
                {row.cells?.map((cell) => (
                  <td
                    key={cell.id}
                    className={`px-4 py-3.5 align-middle ${
                      cell.highlight ? 'text-brand-500 text-[28px] leading-none font-light' : 'text-grey-800'
                    }`}
                  >
                    <div className="inline [&_p]:m-0 [&_p]:inline">
                      <Markdown>{cell.content || ''}</Markdown>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </figure>
  );
};

export default GlossaryTable;
